module.exports = __webpack_public_path__ + "img/Photo Dec 03, 4 45 27 PM.d4833518.jpg";